// Backend endpoints per environment. The active one is picked at build time
// from the git branch being built (see vue.config.js): main -> prod,
// anything else -> dev, and `npm run serve` -> local.
const SERVER_ENDPOINTS = {
  prod: "https://prod-rh-backend.k-9apps.com",
  dev: "https://dev-rh-backend.k-9apps.com",
  local: "http://localhost:8000",
};

export const APP_ENV = process.env.VUE_APP_ENV || "dev";

export const SERVER_ENDPOINT = SERVER_ENDPOINTS[APP_ENV];
